/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import uniq from 'lodash/uniq';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';
import { isMessage } from '../../lib/utils';

import styles from '../../../styles/fields/select.module.css';

const propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    errors: AppPropTypes.formErrors,
    multiple: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({})),
    wide: PropTypes.bool,
    className: PropTypes.string,
    onChange: PropTypes.func,
};

const SelectField = ({
    name = null,
    value = null,
    errors = null,
    multiple = false,
    required = false,
    disabled = false,
    options = [],
    wide = false,
    className = null,
    onChange = null,
}) => {
    const intl = useIntl();

    const onInputChange = useCallback(
        (e) => {
            if (onChange !== null) {
                e.preventDefault();
                e.stopPropagation();
                const { value: newValue = null } = e.currentTarget;
                if (multiple) {
                    if (value !== null && value.includes(newValue)) {
                        onChange([...value.filter((v) => v !== newValue)]);
                    } else {
                        onChange(uniq([...(value || []), newValue]));
                    }
                } else {
                    onChange(newValue);
                }
            }
        },
        [value, onChange, multiple],
    );

    return (
        <select
            name={name}
            value={value || (multiple ? [] : null)}
            multiple={multiple}
            onChange={onInputChange}
            // onClick={onClick}
            required={required}
            disabled={disabled}
            className={classNames([
                styles.container,
                {
                    [styles.wide]: wide,
                    [styles.hasErrors]: errors !== null && errors.length > 0,
                    [className]: className !== null,
                },
            ])}
        >
            {options.map(({ value: optionValue, label: optionLabel }) => (
                <option className={styles.option} key={`option-${optionValue}`} value={optionValue}>
                    {isMessage(optionLabel) ? intl.formatMessage(optionLabel) : optionLabel}
                </option>
            ))}
        </select>
    );
};

SelectField.propTypes = propTypes;

export default SelectField;
